export default "/static/f3564c5365187cb9.png"